import { useState, useEffect } from 'react'
import { useTranslations } from '../store/translations/hooks'
import { TK } from '../store/translations/translationKeys'
import { getConsent, setConsent } from '../cookieConsent'
import { initAnalytics, sendPageView } from '../analytics'

const CookieBanner = () => {
    const t = useTranslations()
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const consent = getConsent()
        if (consent === null) {
            setVisible(true)
        } else if (consent === 'accepted') {
            initAnalytics()
            sendPageView()
        }
    }, [])

    const handleAccept = () => {
        setConsent('accepted')
        initAnalytics()
        sendPageView()
        setVisible(false)
    }

    const handleDecline = () => {
        setConsent('declined')
        setVisible(false)
    }

    if (!visible) return null

    return (
        <div style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '#1a1a2e',
            color: '#fff',
            padding: '12px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
            zIndex: 9999,
            flexWrap: 'wrap',
            fontSize: '0.875rem',
        }}>
            <span style={{ flex: 1, minWidth: 200 }}>
                {t(TK.cookieConsentMessage)}
            </span>
            <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
                <button onClick={handleDecline} style={{
                    padding: '6px 16px',
                    border: '1px solid rgba(255,255,255,0.4)',
                    borderRadius: 4,
                    background: 'transparent',
                    color: '#fff',
                    cursor: 'pointer',
                    fontSize: '0.875rem',
                }}>
                    {t(TK.cookieConsentDecline)}
                </button>
                <button onClick={handleAccept} style={{
                    padding: '6px 16px',
                    border: 'none',
                    borderRadius: 4,
                    background: '#4CAF50',
                    color: '#fff',
                    cursor: 'pointer',
                    fontSize: '0.875rem',
                    fontWeight: 600,
                }}>
                    {t(TK.cookieConsentAccept)}
                </button>
            </div>
        </div>
    )
}

export default CookieBanner
